export default {
  id: 'openApi.SalesJobServiceMutator',
  matches: {},
  mutate: (apiModel, cxt) => {
    if (apiModel.info.title !== 'SaleJobService') {
      return apiModel;
    }
    const {
      molten
    } = cxt;
    const systemId = molten.getConfig('api/systemId');
    let nApiModel = {
      ...apiModel
    };
    if (nApiModel.paths) {
      nApiModel.paths = {
        ...nApiModel.paths
      };
      Object.entries(nApiModel.paths).forEach(([key, val]) => {
        const nKey = key.replaceAll(':systemId', systemId);
        nApiModel.paths[nKey] = nApiModel.paths[key];
        delete nApiModel.paths[key];
      });
    }
    nApiModel = {
      ...nApiModel,
      'x-lev-options': {
        ...nApiModel['x-lev-options'],
        basePath: nApiModel['x-lev-options'].basePath.replaceAll(':systemId', systemId)
      }
    };
    return nApiModel;
  }
};